//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    logout
} from "@/assets/api/dataBase.js";
import {
    utils
} from "@/assets/utils/utils.js";
import {
    location
} from "@/assets/utils/gps.js";//经纬度信息
import dbmap from '@/assets/dbs/hashmap.js'
export default {
    name: 'app',
    data(){
        return{
            isConfirmInf: false,
            jumpCode:'',
            gps:{},//经纬度信息
        }
    },
    mounted(){
        //获取经纬度
        // this.getLocation();
    },
    methods:{
        jumpPage(data){
            this.isConfirmInf = true
            this.jumpCode = data
        },
        proceed(data){
            if(data === '1'){
                window.open("https://beian.miit.gov.cn/")
            }else if(data === '2'){
                window.open("http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020170821174538000002010036-SAIC_SHOW_310000-20171101111325737110&signData=MEUCIQCHH0AE1EpV+6swwZ5EXSTVqcbF2K1KRJFO6oJAyzvMuAIgDaPz3iuhsqJKwkFNGAtxSG/0T/hnc7FIV273241+8b0=")
            }else if(data === '3'){
                window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502400282")
            }
            this.isConfirmInf = false
        },
        loginOut(){
            logout({}).then(result => {
                if (result.responseCode == "000000") {
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    this.$router.push({
                        path: url
                    });
                }
            });
        },
        getLocation() {
            //1
            if(window.returnCitySN) {
                let createdIp = returnCitySN['cip']
                dbmap.set('createdIp',createdIp)
                console.log('createdIp',createdIp)
            }

            // 判断是否支持 获取本地位置 2
            // if (navigator.geolocation) {
            //     var n = navigator.geolocation.getCurrentPosition(function(res){
            //         console.log('h5gps',res);
            //     },function(error){
            //         console.log('h5gpserror',error)
            //     });
            // } else {
            //     console.log('h5gps该浏览器不支持定位');
            // }

            //3
            if(window.AMap){
                let _that = this;
                let geolocation = location.initMap("map-container"); //定位
                AMap.event.addListener(geolocation, "complete", result => {
                    _that.gps.lat = result.position.lat;
                    _that.gps.lng = result.position.lng;
                    _that.gps.province = result.addressComponent.province;
                    _that.gps.city = result.addressComponent.city;
                    _that.gps.district = result.addressComponent.district;
                    console.log('gps',_that.gps)
                    let createdLongitude = _that.gps.lat
                    let createdLatitude = _that.gps.lng
                    let createdAddress = _that.gps.province + '|' + _that.gps.city
                    dbmap.set('createdLongitude',createdLongitude)
                    dbmap.set('createdLatitude',createdLatitude)
                    dbmap.set('createdAddress',createdAddress)
                },err=>{
                    console.log('gpserr',err)
                });
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/App.vue